module.exports = __webpack_public_path__ + "static/media/reset.201d43d5.svg";